import { ToastContainer } from "react-toastify";

import { getPreviewTheme } from "config/previewTheme";
import { getLandingComponent } from "config/landingPage";
import { shouldWarmDevice } from "config/bizHost";
import { useLayoutEffect } from "react";
import { useMyStore } from "store";
import { useGA } from "hooks/useGA";
import { getDeviceFingerprint, injectOneDeviceCollect } from "utils/device";
import { installPageHideTracking } from "utils/dataLayer";

const LandingPage = () => {
  const Component = getLandingComponent(getPreviewTheme() ?? undefined);
  return <Component />;
};

const App = () => {
  const getBootstrap = useMyStore((s) => s.getBootstrap);
  const { injectGA } = useGA();

  useLayoutEffect(() => {
    if (shouldWarmDevice(window.location.hostname, window.location.search)) {
      injectOneDeviceCollect();
      getDeviceFingerprint().catch(() => {});
    }

    installPageHideTracking();

    // Nothing below gates the first paint any more: the hostname already says
    // which page to draw, so bootstrap and the device id catch up in their own
    // time. The signup form and the game link read them when the user gets
    // there, seconds later.
    getBootstrap()
      .then((bootstrap) => injectGA(bootstrap.gtagId))
      .catch(() => {});
  }, []);

  return (
    <>
      <LandingPage />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
};

export default App;
